import React from "react";
import { useParams } from "react-router-dom";
import { useGroupStore } from "../store/groupStore";
import { useClinicianStore } from "../store/clinicianStore";
import { GroupMetrics } from "../components/group/GroupMetrics";
import { ClinicianManagement } from "../components/group/ClinicianManagement";
import { DashboardLayout } from '../layouts/DashboardLayout';
import { useAuthStore } from "../store/authStore";
import { GroupSettings } from "../components/group/GroupSettings";
import { EmbedCodeGenerator } from "../components/group/EmbedCodeGenerator";

interface NavItem {
  name: string;
  href: string;
  icon: React.ElementType;
}

export const GroupDashboardPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const group = useGroupStore((state) => state.groups.find((g) => g.id === id));
  const clinicians = useClinicianStore((state) =>
    state.clinicians.filter(
      (c) => c.groupId === id && c.verificationStatus === "verified"
    )
  );
  const { user } = useAuthStore();

  

  return (

     <DashboardLayout>
      {/* Main Content */}
      <div className="flex-1 p-5">
        <div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="lg:col-span-2 space-y-6">
               {/* <GroupMetrics /> */}
               <ClinicianManagement />
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

